import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';

import Employees from 'compositions/Employees';
import ContactHero from 'compositions/ContactHero';
import getSeo from 'utils/helpers/getSeo';

const ContactPage = ({ data }) => {
	const seo = getSeo(data.page);
	return (
		<div>
			<SEO {...seo} keywords={[`contact`, `Kontakt`, `Information`]} />
			<ContactHero page={data.page} />
			<Employees employees={data.employees} />
		</div>
	);
};

export const query = graphql`
	query {
		employees: allContentfulEmployee(sort: { order: DESC, fields: [order, createdAt] }) {
			edges {
				node {
					id
					image {
						file {
							contentType
							url
						}
						fluid {
							...GatsbyContentfulFluid
						}
					}
					cursor {
						file {
							url
						}
					}
					title
					name
					phoneNumber
					email
				}
			}
		}
		page: contentfulPageContact {
			headline
			seo {
				ogText
				ogDescription
				ogImage {
					file {
						url
					}
				}
			}
			text {
				text
				childMarkdownRemark {
					html
					rawMarkdownBody
				}
			}
			image {
				file {
					contentType
					url
				}
				fluid {
					...GatsbyContentfulFluid
				}
			}
		}
	}
`;

export default ContactPage;
